/* eslint-disable no-return-assign */
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  InputLabel,
  TextField,
  Typography,
} from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { Component } from 'react';
import { injectIntl } from 'react-intl';
import { AgentChatTransferStatus } from '../../model/frontendmodel';
import TypeUtils from '../../utils/typeutils';
import ChatHistory from '../ChatTimeline/ChatHistory';
import { NoticeBox } from '../Misc';
import './ActiveChat.css';
import AlertMaxSizeImage from './AlertMaxSizeImage';
import EmptyView from './EmptyView';

class ActiveChat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agentChatTransferTargetRejectComments: '',
      agentChatTransferTargetRejectDialog: false,
      isScrolledAtBottom: true,
    };

    this.state = {
      agentChatTransferTargetRejectComments: '',
      agentChatTransferTargetRejectDialog: false,
      isScrolledAtBottom: true,
    };

    this.user = window.store.getState().loginAuthentication?.success?.id;

    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.scrollToElement = this.scrollToElement.bind(this);
    this.handleTimelineScrolled = this.handleTimelineScrolled.bind(this);
    this.renderErrorExportingChatToCrmNotice =
      this.renderErrorExportingChatToCrmNotice.bind(this);
  }

  componentDidUpdate(prevProps) {
    const prevActiveChat = prevProps.activeChat;
    const { activeChat, loadedImagesErrors } = this.props;
    const { isScrolledAtBottom } = this.state;

    if (
      !TypeUtils.isUndefinedOrNull(activeChat) &&
      !TypeUtils.isUndefinedOrNull(prevActiveChat)
    ) {
      const activeChatEvents = activeChat.events;
      const prevActiveChatEvents = prevActiveChat.events;

      // Scroll to bottom when user switched the active chat
      if (activeChat.id && activeChat.id !== prevActiveChat.id) {
        this.scrollToBottom();
      }

      // If new events are set in the Timeline, auto-scroll the Chat Box to make them visible
      if (
        activeChatEvents &&
        prevActiveChatEvents &&
        activeChatEvents.length > prevActiveChatEvents.length
      ) {
        if (isScrolledAtBottom) {
          this.scrollToBottom();
        }
      }
    }

    if (prevProps.loadedImagesErrors?.length < loadedImagesErrors?.length) {
      this.scrollToBottom();
    }
  }

  componentDidMount() {
    this.scrollToBottom();
  }

  scrollToBottom = () => {
    this.scrollToElement(this.markEndOfTimeline, false);
  };

  scrollToElement = (el, translateToCenter = false) => {
    if (!this.domTimelineSection || !this.domTimelineSection.children) {
      return;
    }

    let newScrollTop = 0;
    let translationY = 0;

    if (
      !TypeUtils.isUndefinedOrNull(el) &&
      !TypeUtils.isUndefinedOrNull(el.offsetTop)
    ) {
      newScrollTop = el.offsetTop;
    }

    if (translateToCenter) {
      translationY = Math.round(this.domTimelineSection.clientHeight / 2);
    }

    if (newScrollTop > 0) {
      this.domTimelineSection.scrollTop = Math.max(
        newScrollTop - translationY,
        0
      );
    }
  };

  handleTimelineScrolled = ev => {
    if (!this.domTimelineSection || !this.domTimelineSection.children) {
      return;
    }

    // When the user scrolls down to the bottom of the timeline, set the state property isScrolledAtBottom
    // to true, which says if the timeline should stay scrolled at the bottom when contents change
    const scrollTolerance = 100;
    const scrollBottom =
      ev.target.scrollTop +
      this.domTimelineSection.clientHeight +
      scrollTolerance;
    const { isScrolledAtBottom } = this.state;

    if (
      isScrolledAtBottom &&
      scrollBottom < this.domTimelineSection.scrollHeight
    ) {
      this.setState({ isScrolledAtBottom: false });
    } else if (scrollBottom >= this.domTimelineSection.scrollHeight) {
      this.setState({ isScrolledAtBottom: true });
    }
  };

  handleHistoryScrollHeightUpdated = prevLastChatId => {
    const { isScrolledAtBottom } = this.state;
    if (isScrolledAtBottom) {
      this.scrollToBottom();
    } else if (!TypeUtils.isUndefinedOrNull(prevLastChatId)) {
      if (!TypeUtils.isUndefinedOrNull(this.domTimelineSection)) {
        const prevLastChatEl = this.domTimelineSection.querySelector(
          `#${prevLastChatId}`
        );

        this.scrollToElement(prevLastChatEl, true);
      }
    }
  };

  onAgentChatTransferRequestCancel = () => {
    const { activeChat, onCancelAgentChatTransfer } = this.props;
    onCancelAgentChatTransfer({ chatId: activeChat.id });
  };

  onAgentChatTransferDialogRejectCancel = () => {
    this.setState({
      agentChatTransferTargetRejectDialog: false,
      agentChatTransferTargetRejectComments: '',
    });
  };

  onAgentChatTransferDialogReject = () => {
    const { activeChat, onRejectAgentChatTransfer } = this.props;
    const { agentChatTransferTargetRejectComments } = this.state;
    const transfer = activeChat.chatXferRequest;
    transfer.rejectReason = agentChatTransferTargetRejectComments;
    onRejectAgentChatTransfer(transfer);
    transfer.status = AgentChatTransferStatus.REJECTED;
    this.setState({
      agentChatTransferTargetRejectDialog: false,
      agentChatTransferTargetRejectComments: '',
    });
  };

  onAgentChatTransferReject = () => {
    this.setState({ agentChatTransferTargetRejectDialog: true });
  };

  onAgentChatTransferApprove = () => {
    const { activeChat, onAcceptAgentChatTransfer } = this.props;
    const transfer = activeChat.chatXferRequest;
    transfer.status = AgentChatTransferStatus.ACCEPTED;
    onAcceptAgentChatTransfer(transfer);
  };

  onAgentChatTransferTargetRejectCommentsChange = event => {
    this.setState({
      agentChatTransferTargetRejectComments: event.target.value,
    });
  };

  renderAgentChatTransferContainer = () => {
    const { activeChat, intl } = this.props;
    const { formatMessage } = intl;
    const transfer = activeChat.chatXferRequest;
    let message = null;

    const source = () => {
      if (
        [
          AgentChatTransferStatus.REQUESTED,
          AgentChatTransferStatus.PICKED_UP,
        ].includes(transfer.status)
      ) {
        message = formatMessage(
          { id: 'ChatTransfer.activeChatTransferSourceRequest' },
          { targetAgent: transfer.targetAgent.fullName }
        );
        return (
          // eslint-disable-next-line react/jsx-filename-extension
          <div className="transferDialog">
            <p className="Text">{message}</p>
            <Button
              color="primary"
              variant="contained"
              onClick={this.onAgentChatTransferRequestCancel}
            >
              {formatMessage({
                id: 'ChatTransfer.activeChatTransferSourceRequestCancel',
              })}
            </Button>
          </div>
        );
      }

      if (AgentChatTransferStatus.REJECTED === transfer.status) {
        message = formatMessage(
          { id: 'ChatTransfer.activeChatTransferSourceReject' },
          {
            targetAgent: transfer.targetAgent.fullName,
          }
        );
        return (
          <p
            className="Text"
            style={{
              fontSize: '0.87em',
              padding: '25px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <InfoIcon
              className="material-icons"
              style={{ fontSize: '20px', marginRight: '5px' }}
            />
            {message}
            <br />
            {transfer?.rejectReason?.length && `${transfer.rejectReason}.`}
          </p>
        );
      }

      if (AgentChatTransferStatus.ACCEPTED === transfer.status) {
        return (
          <div
            className="Text"
            style={{
              fontSize: '0.87em',
              padding: '25px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <InfoIcon
              className="material-icons"
              style={{ fontSize: '20px', marginRight: '5px' }}
            />
            {formatMessage(
              { id: 'ChatTransfer.activeChatTransferSourceAccept' },
              {
                targetAgent: transfer.targetAgent.fullName,
              }
            )}
          </div>
        );
      }
      return null;
    };

    const target = () => {
      const {
        agentChatTransferTargetRejectDialog,
        agentChatTransferTargetRejectComments,
      } = this.state;
      if (
        [
          AgentChatTransferStatus.REQUESTED,
          AgentChatTransferStatus.PICKED_UP,
        ].includes(transfer.status)
      ) {
        message = formatMessage(
          { id: 'ChatTransfer.transferRequestTargetItemMessage' },
          {
            sourceAgent: transfer.sourceAgent.fullName,
          }
        );

        return (
          <div className="transferDialog">
            <Typography variant="body1">{message}</Typography>
            <Typography
              style={{ marginTop: 8, marginBottom: 8 }}
              variant="body2"
            >
              {`${transfer.comments}.`}
            </Typography>
            <Box display="flex" justifyContent="center">
              <Button
                color="primary"
                variant="outlined"
                onClick={this.onAgentChatTransferReject}
                style={{ marginRight: 8 }}
              >
                {formatMessage({
                  id: 'ChatTransfer.activeChatTransferTargetReject',
                })}
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={this.onAgentChatTransferApprove}
              >
                {formatMessage({
                  id: 'ChatTransfer.activeChatTransferTargetApprove',
                })}
              </Button>
            </Box>
            <Dialog
              open={agentChatTransferTargetRejectDialog}
              maxWidth="xs"
              fullWidth
            >
              <DialogTitle>
                {formatMessage({
                  id: 'ChatTransfer.activeChatTransferDialogRejectTitle',
                })}
              </DialogTitle>
              <DialogContent>
                <InputLabel>
                  {formatMessage({
                    id: 'ChatTransfer.activeChatTransferDialogRejectMessage',
                  })}
                </InputLabel>
                <TextField
                  id="ActiveChat.agentChatTransferTargetRejectComments"
                  multiline
                  minRows={2}
                  maxRows={4}
                  variant="outlined"
                  margin="dense"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  value={agentChatTransferTargetRejectComments}
                  onChange={this.onAgentChatTransferTargetRejectCommentsChange}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={this.onAgentChatTransferDialogRejectCancel}
                >
                  {formatMessage({
                    id: 'ChatTransfer.activeChatTransferTargetRejectCancel',
                  })}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.onAgentChatTransferDialogReject}
                  disabled={
                    !agentChatTransferTargetRejectComments ||
                    agentChatTransferTargetRejectComments.length === 0
                  }
                >
                  {formatMessage({
                    id: 'ChatTransfer.activeChatTransferTargetReject',
                  })}
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        );
      }
      if (transfer.status === AgentChatTransferStatus.CANCELLED) {
        return (
          <div
            className="Text"
            style={{
              fontSize: '0.87em',
              padding: '25px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <InfoIcon
              className="material-icons"
              style={{ fontSize: '20px', marginRight: '5px' }}
            />

            {formatMessage(
              { id: 'ChatTransfer.transferCancelTargetDialogMessage' },
              {
                sourceAgent: transfer.sourceAgent.fullName,
              }
            )}
          </div>
        );
      }
      return null;
    };

    return transfer.sourceAgent.id === this.user ? source() : target();
  };

  renderErrorClosingChatNotice(errorClosingChat) {
    const { onAcknowledgeLastChatCloseError } = this.props;
    let errorMessageId = null;

    switch (errorClosingChat.code) {
      case 'INVALID_CONTACT':
      case 'CREATE_CONTACT_SERVICE_ERROR':
      case 'UPDATE_CONTACT_SERVICE_ERROR':
        errorMessageId = 'ActiveChat.errorClosingChatInvalidContact';
        break;

      default:
        errorMessageId = 'ActiveChat.errorClosingChatUnknown';
    }

    return (
      <NoticeBox
        open
        width="32em"
        messageId={errorMessageId}
        onOk={onAcknowledgeLastChatCloseError}
      />
    );
  }

  renderErrorExportingChatToCrmNotice(chatCrmExportError) {
    const {
      intl: { formatMessage },
      onAcknowledgeLastChatCrmExportError,
    } = this.props;
    if (chatCrmExportError?.message) {
      let errorMessageId = 'ActiveChat.errorExportingChatToCrm.message';
      let errorDetailsEl = null;

      const headColStyle = {
        display: 'inline-block',
        fontStyle: 'italic',
        width: '7em',
        marginTop: '0.25em',
        verticalAlign: 'top',
      };

      const textColStyle = {
        display: 'inline-block',
        width: '27em',
        marginTop: '0.25em',
        verticalAlign: 'top',
        overflowWrap: 'break-word',
      };

      // Check if the error is a known validation
      if (chatCrmExportError.code === 'INVALID_VALUE') {
        errorMessageId = 'ActiveChat.errorExportingChatToCrm.invalidEmail';
      } else {
        errorDetailsEl = (
          <div style={{ fontSize: '0.85em', marginTop: '1em', width: '35em' }}>
            <div style={headColStyle}>Timestamp: </div>
            <div style={textColStyle}>{chatCrmExportError.timestamp}</div>
            <div style={headColStyle}>Details: </div>
            <div style={textColStyle}>{chatCrmExportError.message}</div>
          </div>
        );
      }

      return (
        <NoticeBox
          open
          width="37em"
          messageId={errorMessageId}
          details={errorDetailsEl}
          title={formatMessage({
            id: 'ActiveChat.errorExportingChatToCrm.title',
            defaultMessage: 'Error',
          })}
          onOk={onAcknowledgeLastChatCrmExportError}
        />
      );
    }

    return null;
  }

  render() {
    const {
      isAwaitingActiveChatSwitch,
      isAwaitingActiveChatClose,
      activeChat,
      lastChatCloseError,
      lastChatCrmExportError,
      loadedImagesErrors,
    } = this.props;
    let activatingChatDialog = null;
    let closingChatDialog = null;

    // Render a dialog informing that a new chat is being set up as active
    if (isAwaitingActiveChatSwitch) {
      activatingChatDialog = null;
    }

    // Render a dialog informing that the currently active chat is being closed
    if (isAwaitingActiveChatClose) {
      closingChatDialog = null;
    }

    let errorClosingChatNotice = null;
    let errorExportingChatToCrm = null;

    if (lastChatCloseError) {
      errorClosingChatNotice =
        this.renderErrorClosingChatNotice(lastChatCloseError);
    }

    if (lastChatCrmExportError) {
      errorExportingChatToCrm = this.renderErrorExportingChatToCrmNotice(
        lastChatCrmExportError
      );
    }

    let agentChatTransferContainer;
    if (activeChat && activeChat.chatXferRequest) {
      agentChatTransferContainer = this.renderAgentChatTransferContainer();
    }

    return (
      <div id="chatbox" className="ChatBox" data-testid="active-chat">
        {Object.keys(activeChat).length === 0 && <EmptyView />}
        <ChatHistory />
        <Grid container justifyContent="flex-end">
          <AlertMaxSizeImage
            activeProviderName={activeChat?.provider}
            loadedImagesErrors={loadedImagesErrors}
          />
        </Grid>
        {agentChatTransferContainer}
        {activatingChatDialog}
        {closingChatDialog}
        {errorClosingChatNotice}
        {errorExportingChatToCrm}
      </div>
    );
  }
}

export default injectIntl(ActiveChat);
